// @ts-nocheck
type Theme = {
  background0: string;
  background025: string;
  background05: string;
  background075: string;
  color1: string;
  color2: string;
  color3: string;
  color4: string;
  color5: string;
  color6: string;
  color7: string;
  color8: string;
  color9: string;
  color10: string;
  color11: string;
  color12: string;
  color13: string;
  color0: string;
  color025: string;
  color05: string;
  color075: string;
  background: string;
  backgroundHover: string;
  backgroundPress: string;
  backgroundFocus: string;
  borderColor: string;
  borderColorHover: string;
  borderColorPress: string;
  borderColorFocus: string;
  color: string;
  colorHover: string;
  colorPress: string;
  colorFocus: string;
  colorTransparent: string;
  placeholderColor: string;
  outlineColor: string;
  textSecondary: string;
  backgroundSecondary: string;
  backgroundTertiary: string;
  groupedPrimary: string;
  groupedSecondary: string;
  strokePrimary: string;
  cream1: string;
  cream2: string;
  cream3: string;
  cream4: string;
  cream5: string;
  cream6: string;
  cream7: string;
  cream8: string;
  cream9: string;
  cream10: string;
  cream11: string;
  cream12: string;
  cream13: string;
  gray1: string;
  gray2: string;
  gray3: string;
  gray4: string;
  gray5: string;
  gray6: string;
  gray7: string;
  gray8: string;
  gray9: string;
  gray10: string;
  gray11: string;
  gray12: string;
  gray13: string;
  green1: string;
  green2: string;
  green3: string;
  green4: string;
  green5: string;
  green6: string;
  green7: string;
  green8: string;
  green9: string;
  green10: string;
  green11: string;
  green12: string;
  green13: string;
  lightblue1: string;
  lightblue2: string;
  lightblue3: string;
  lightblue4: string;
  lightblue5: string;
  lightblue6: string;
  lightblue7: string;
  lightblue8: string;
  lightblue9: string;
  lightblue10: string;
  lightblue11: string;
  lightblue12: string;
  lightblue13: string;
  limegreen1: string;
  limegreen2: string;
  limegreen3: string;
  limegreen4: string;
  limegreen5: string;
  limegreen6: string;
  limegreen7: string;
  limegreen8: string;
  limegreen9: string;
  limegreen10: string;
  limegreen11: string;
  limegreen12: string;
  limegreen13: string;
  navy1: string;
  navy2: string;
  navy3: string;
  navy4: string;
  navy5: string;
  navy6: string;
  navy7: string;
  navy8: string;
  navy9: string;
  navy10: string;
  navy11: string;
  navy12: string;
  navy13: string;
  orange1: string;
  orange2: string;
  orange3: string;
  orange4: string;
  orange5: string;
  orange6: string;
  orange7: string;
  orange8: string;
  orange9: string;
  orange10: string;
  orange11: string;
  orange12: string;
  orange13: string;
  red1: string;
  red2: string;
  red3: string;
  red4: string;
  red5: string;
  red6: string;
  red7: string;
  red8: string;
  red9: string;
  red10: string;
  red11: string;
  red12: string;
  red13: string;
  shadowColor: string;
  shadowColorHover: string;
  shadowColorPress: string;
  shadowColorFocus: string;
  navy: string;
  lightblue: string;
  cream: string;
  limegreen: string;
  strokeSecondary: string;
  strokeTertiary: string;
  textTertiary: string;

}

function t(a: [number, number][]) {
  let res: Record<string,string> = {}
  for (const [ki, vi] of a) {
    res[ks[ki] as string] = colors[vi] as string
  }
  return res as Theme
}
export const colors = [
  'hsla(0, 0%, 100%, 0)',
  'hsla(0, 0%, 100%, 0.25)',
  'hsla(0, 0%, 100%, 0.5)',
  'hsla(0, 0%, 100%, 0.75)',
  'hsl(0, 0%, 100%)',
  'hsl(40, 60%, 99.02%)',
  'hsl(36, 55.56%, 96.47%)',
  'hsl(36, 50%, 96.08%)',
  'hsl(42, 29.41%, 93.33%)',
  'hsl(36.92, 11.3%, 77.45%)',
  'hsl(218.01, 10.4%, 62.38%)',
  'hsl(217.9, 20.15%, 47.65%)',
  'hsl(218.24, 43.54%, 33.24%)',
  'hsl(219.38, 100%, 18.82%)',
  'hsl(36, 2.56%, 38.24%)',
  'hsl(228, 61.64%, 14.31%)',
  'hsla(219.38, 100%, 18.82%, 0)',
  'hsla(219.38, 100%, 18.82%, 0.25)',
  'hsla(219.38, 100%, 18.82%, 0.5)',
  'hsla(219.38, 100%, 18.82%, 0.75)',
  'hsl(223.81, 0%, 100%)',
  'hsl(35.98, 55.7%, 99.6%)',
  'hsl(35.99, 55.67%, 98.98%)',
  'hsl(35.99, 55.64%, 98.23%)',
  'hsl(35.99, 55.6%, 97.39%)',
  'hsl(36, 22.32%, 90.03%)',
  'hsl(36, 14.64%, 83.69%)',
  'hsl(36, 11.28%, 77.45%)',
  'hsl(36.01, 7.63%, 65.3%)',
  'hsl(36.01, 6.22%, 57.04%)',
  'hsl(36.01, 1.79%, 48.38%)',
  'hsl(36.04, 7.67%, 26.52%)',
  'hsl(223.81, 0%, 98.71%)',
  'hsl(223.81, 0%, 96.69%)',
  'hsl(223.81, 0%, 94.28%)',
  'hsl(223.81, 0%, 91.57%)',
  'hsl(223.81, 0%, 88.63%)',
  'hsl(223.81, 0%, 82.78%)',
  'hsl(223.81, 0%, 77.01%)',
  'hsl(223.81, 0%, 71.32%)',
  'hsl(223.81, 0%, 60.2%)',
  'hsl(223.81, 0%, 52.62%)',
  'hsl(223.81, 0%, 44.21%)',
  'hsl(223.81, 0%, 24.44%)',
  'hsl(136.74, 86.72%, 98.03%)',
  'hsl(137.32, 85.98%, 94.88%)',
  'hsl(138.1, 85.17%, 90.94%)',
  'hsl(139.12, 84.37%, 86.27%)',
  'hsl(140.49, 83.67%, 80.78%)',
  'hsl(140.77, 70.06%, 73.76%)',
  'hsl(141.11, 60.58%, 67.19%)',
  'hsl(141.49, 54.35%, 60.68%)',
  'hsl(142.52, 47.08%, 48.55%)',
  'hsl(143.56, 58.97%, 40.26%)',
  'hsl(145.38, 20.72%, 39.02%)',
  'hsl(154.32, 100%, 7.32%)',
  'hsl(198.25, 100%, 98.36%)',
  'hsl(198.17, 100%, 95.77%)',
  'hsl(198.06, 100%, 92.59%)',
  'hsl(197.91, 100%, 88.9%)',
  'hsl(197.69, 100%, 84.71%)',
  'hsl(197.65, 81.32%, 78.57%)',
  'hsl(197.59, 68.54%, 72.62%)',
  'hsl(197.53, 60.36%, 66.74%)',
  'hsl(197.37, 47.47%, 55.42%)',
  'hsl(197.21, 45.32%, 47.71%)',
  'hsl(196.93, 17.13%, 41.59%)',
  'hsl(194.54, 100%, 17.67%)',
  'hsl(81.37, 80.34%, 98.06%)',
  'hsl(80.98, 79.85%, 95%)',
  'hsl(80.49, 79.31%, 91.25%)',
  'hsl(79.89, 78.76%, 86.9%)',
  'hsl(79.17, 78.26%, 81.96%)',
  'hsl(79.02, 62.98%, 74.46%)',
  'hsl(78.85, 53.39%, 67.56%)',
  'hsl(78.66, 47.22%, 60.75%)',
  'hsl(78.19, 40.45%, 48.36%)',
  'hsl(77.74, 50%, 40.06%)',
  'hsl(77.04, 16.19%, 41%)',
  'hsl(72.49, 100%, 9.43%)',
  'hsl(217.64, 28.4%, 90.23%)',
  'hsl(217.67, 27.55%, 75.29%)',
  'hsl(217.79, 26.38%, 57.84%)',
  'hsl(218.13, 39.03%, 38.91%)',
  'hsl(220.31, 100%, 18.76%)',
  'hsl(221.56, 100%, 18.52%)',
  'hsl(223.19, 100%, 18.46%)',
  'hsl(227.94, 100%, 18.08%)',
  'hsl(232.66, 100%, 17.99%)',
  'hsl(238.08, 95%, 6.81%)',
  'hsl(249.82, 100%, 10.51%)',
  'hsl(25.41, 98.66%, 97.62%)',
  'hsl(25.53, 97.04%, 93.85%)',
  'hsl(25.69, 95.18%, 89.23%)',
  'hsl(25.9, 93.19%, 83.89%)',
  'hsl(26.21, 91.15%, 77.84%)',
  'hsl(26.28, 82.85%, 72.28%)',
  'hsl(26.36, 74.38%, 66.83%)',
  'hsl(26.45, 68.27%, 61.43%)',
  'hsl(26.71, 56.23%, 50.89%)',
  'hsl(26.99, 64.42%, 43.64%)',
  'hsl(27.52, 24.99%, 36.97%)',
  'hsl(31.22, 100%, 14.55%)',
  'hsl(2.41, 100%, 97.74%)',
  'hsl(2.13, 100%, 94.09%)',
  'hsl(1.69, 100%, 89.48%)',
  'hsl(1.03, 97.78%, 84.05%)',
  'hsl(0, 91.15%, 77.84%)',
  'hsl(359.8, 90.11%, 74.56%)',
  'hsl(359.58, 83.91%, 70.72%)',
  'hsl(359.31, 79%, 66.88%)',
  'hsl(358.63, 65.23%, 58.15%)',
  'hsl(357.96, 57.5%, 51.87%)',
  'hsl(356.86, 26.63%, 33.91%)',
  'hsl(348.14, 100%, 21.78%)',
  'rgba(0,0,0,0.08)',
  'rgba(0,0,0,0.04)',
  '#002160',
  '#B1E8FF',
  '#FBF7F1',
  '#DEF5AD',
  '#EBE7E0',
  '#ADA8A0',
  'hsla(223.81, 0%, 100%, 0)',
  'hsla(223.81, 0%, 100%, 0.25)',
  'hsla(223.81, 0%, 100%, 0.5)',
  'hsla(223.81, 0%, 100%, 0.75)',
  'hsla(36.01, 6.22%, 57.04%, 0)',
  'hsla(36.01, 6.22%, 57.04%, 0.25)',
  'hsla(36.01, 6.22%, 57.04%, 0.5)',
  'hsla(36.01, 6.22%, 57.04%, 0.75)',
  'hsla(223.81, 0%, 52.62%, 0)',
  'hsla(223.81, 0%, 52.62%, 0.25)',
  'hsla(223.81, 0%, 52.62%, 0.5)',
  'hsla(223.81, 0%, 52.62%, 0.75)',
  'hsla(143.56, 58.97%, 40.26%, 0)',
  'hsla(143.56, 58.97%, 40.26%, 0.25)',
  'hsla(143.56, 58.97%, 40.26%, 0.5)',
  'hsla(143.56, 58.97%, 40.26%, 0.75)',
  'hsla(232.66, 100%, 17.99%, 0)',
  'hsla(232.66, 100%, 17.99%, 0.25)',
  'hsla(232.66, 100%, 17.99%, 0.5)',
  'hsla(232.66, 100%, 17.99%, 0.75)',
  'hsla(26.99, 64.42%, 43.64%, 0)',
  'hsla(26.99, 64.42%, 43.64%, 0.25)',
  'hsla(26.99, 64.42%, 43.64%, 0.5)',
  'hsla(26.99, 64.42%, 43.64%, 0.75)',
  'hsla(357.96, 57.5%, 51.87%, 0)',
  'hsla(357.96, 57.5%, 51.87%, 0.25)',
  'hsla(357.96, 57.5%, 51.87%, 0.5)',
  'hsla(357.96, 57.5%, 51.87%, 0.75)',
  'hsla(77.74, 50%, 40.06%, 0)',
  'hsla(77.74, 50%, 40.06%, 0.25)',
  'hsla(77.74, 50%, 40.06%, 0.5)',
  'hsla(77.74, 50%, 40.06%, 0.75)',
  'hsla(197.21, 45.32%, 47.71%, 0)',
  'hsla(197.21, 45.32%, 47.71%, 0.25)',
  'hsla(197.21, 45.32%, 47.71%, 0.5)',
  'hsla(197.21, 45.32%, 47.71%, 0.75)',
  'rgba(0,0,0,0.5)',
  '$body',
]

const ks = [
'background0',
'background025',
'background05',
'background075',
'color1',
'color2',
'color3',
'color4',
'color5',
'color6',
'color7',
'color8',
'color9',
'color10',
'color11',
'color12',
'color13',
'color0',
'color025',
'color05',
'color075',
'background',
'backgroundHover',
'backgroundPress',
'backgroundFocus',
'borderColor',
'borderColorHover',
'borderColorPress',
'borderColorFocus',
'color',
'colorHover',
'colorPress',
'colorFocus',
'colorTransparent',
'placeholderColor',
'outlineColor',
'textSecondary',
'backgroundSecondary',
'backgroundTertiary',
'groupedPrimary',
'groupedSecondary',
'strokePrimary',
'cream1',
'cream2',
'cream3',
'cream4',
'cream5',
'cream6',
'cream7',
'cream8',
'cream9',
'cream10',
'cream11',
'cream12',
'cream13',
'gray1',
'gray2',
'gray3',
'gray4',
'gray5',
'gray6',
'gray7',
'gray8',
'gray9',
'gray10',
'gray11',
'gray12',
'gray13',
'green1',
'green2',
'green3',
'green4',
'green5',
'green6',
'green7',
'green8',
'green9',
'green10',
'green11',
'green12',
'green13',
'lightblue1',
'lightblue2',
'lightblue3',
'lightblue4',
'lightblue5',
'lightblue6',
'lightblue7',
'lightblue8',
'lightblue9',
'lightblue10',
'lightblue11',
'lightblue12',
'lightblue13',
'limegreen1',
'limegreen2',
'limegreen3',
'limegreen4',
'limegreen5',
'limegreen6',
'limegreen7',
'limegreen8',
'limegreen9',
'limegreen10',
'limegreen11',
'limegreen12',
'limegreen13',
'navy1',
'navy2',
'navy3',
'navy4',
'navy5',
'navy6',
'navy7',
'navy8',
'navy9',
'navy10',
'navy11',
'navy12',
'navy13',
'orange1',
'orange2',
'orange3',
'orange4',
'orange5',
'orange6',
'orange7',
'orange8',
'orange9',
'orange10',
'orange11',
'orange12',
'orange13',
'red1',
'red2',
'red3',
'red4',
'red5',
'red6',
'red7',
'red8',
'red9',
'red10',
'red11',
'red12',
'red13',
'shadowColor',
'shadowColorHover',
'shadowColorPress',
'shadowColorFocus',
'navy',
'lightblue',
'cream',
'limegreen',
'strokeSecondary',
'strokeTertiary',
'textTertiary']


const n1 = t([[0, 0],[1, 1],[2, 2],[3, 3],[4, 4],[5, 5],[6, 6],[7, 7],[8, 8],[9, 9],[10, 10],[11, 11],[12, 12],[13, 13],[14, 13],[15, 14],[16, 15],[17, 16],[18, 17],[19, 18],[20, 19],[21, 4],[22, 3],[23, 6],[24, 6],[25, 9],[26, 13],[27, 13],[28, 13],[29, 15],[30, 13],[31, 15],[32, 13],[33, 17],[34, 14],[35, 18],[36, 14],[37, 5],[38, 6],[39, 7],[40, 8],[41, 9],[42, 20],[43, 21],[44, 22],[45, 23],[46, 24],[47, 6],[48, 25],[49, 26],[50, 27],[51, 28],[52, 29],[53, 30],[54, 31],[55, 20],[56, 32],[57, 33],[58, 34],[59, 35],[60, 36],[61, 37],[62, 38],[63, 39],[64, 40],[65, 41],[66, 42],[67, 43],[68, 20],[69, 44],[70, 45],[71, 46],[72, 47],[73, 48],[74, 49],[75, 50],[76, 51],[77, 52],[78, 53],[79, 54],[80, 55],[81, 20],[82, 56],[83, 57],[84, 58],[85, 59],[86, 60],[87, 61],[88, 62],[89, 63],[90, 64],[91, 65],[92, 66],[93, 67],[94, 20],[95, 68],[96, 69],[97, 70],[98, 71],[99, 72],[100, 73],[101, 74],[102, 75],[103, 76],[104, 77],[105, 78],[106, 79],[107, 20],[108, 80],[109, 81],[110, 82],[111, 83],[112, 13],[113, 84],[114, 85],[115, 86],[116, 87],[117, 88],[118, 89],[119, 90],[120, 20],[121, 91],[122, 92],[123, 93],[124, 94],[125, 95],[126, 96],[127, 97],[128, 98],[129, 99],[130, 100],[131, 101],[132, 102],[133, 20],[134, 103],[135, 104],[136, 105],[137, 106],[138, 107],[139, 108],[140, 109],[141, 110],[142, 111],[143, 112],[144, 113],[145, 114],[146, 115],[147, 115],[148, 116],[149, 116],[150, 117],[151, 118],[152, 119],[153, 120],[154, 121],[155, 119],[156, 122]])
const n2 = t([[0, 0],[1, 1],[2, 2],[3, 3],[4, 4],[5, 5],[6, 6],[7, 7],[8, 8],[9, 9],[10, 10],[11, 11],[12, 12],[13, 13],[14, 13],[15, 14],[16, 15],[17, 16],[18, 17],[19, 18],[20, 19],[21, 4],[22, 3],[23, 6],[24, 6],[25, 9],[26, 13],[27, 13],[28, 13],[29, 15],[30, 13],[31, 15],[32, 13],[33, 17],[34, 14],[35, 18],[36, 14],[37, 5],[38, 6],[39, 7],[40, 8],[41, 9]])
const n3 = t([[0, 0],[1, 1],[2, 2],[3, 3],[4, 4],[5, 5],[6, 6],[7, 7],[8, 8],[9, 9],[10, 10],[11, 11],[12, 12],[13, 13],[14, 13],[15, 14],[16, 15],[17, 16],[18, 17],[19, 18],[20, 19],[21, 4],[22, 3],[23, 5],[24, 5],[25, 14],[26, 15],[27, 15],[28, 15],[29, 15],[30, 14],[31, 15],[32, 14],[33, 17],[34, 14],[35, 18],[36, 14]])
const n4 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 21],[6, 22],[7, 23],[8, 24],[9, 6],[10, 25],[11, 26],[12, 27],[13, 28],[14, 29],[15, 30],[16, 31],[17, 127],[18, 128],[19, 129],[20, 130],[21, 20],[22, 126],[23, 21],[24, 21],[25, 30],[26, 31],[27, 31],[28, 31],[29, 31],[30, 30],[31, 31],[32, 30],[33, 128],[34, 30],[35, 129],[36, 30]])
const n5 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 32],[6, 33],[7, 34],[8, 35],[9, 36],[10, 37],[11, 38],[12, 39],[13, 40],[14, 41],[15, 42],[16, 43],[17, 131],[18, 132],[19, 133],[20, 134],[21, 20],[22, 126],[23, 32],[24, 32],[25, 42],[26, 43],[27, 43],[28, 43],[29, 43],[30, 42],[31, 43],[32, 42],[33, 132],[34, 42],[35, 133],[36, 42]])
const n6 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 44],[6, 45],[7, 46],[8, 47],[9, 48],[10, 49],[11, 50],[12, 51],[13, 52],[14, 53],[15, 54],[16, 55],[17, 135],[18, 136],[19, 137],[20, 138],[21, 20],[22, 126],[23, 44],[24, 44],[25, 54],[26, 55],[27, 55],[28, 55],[29, 55],[30, 54],[31, 55],[32, 54],[33, 136],[34, 54],[35, 137],[36, 54]])
const n7 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 80],[6, 81],[7, 82],[8, 83],[9, 13],[10, 84],[11, 85],[12, 86],[13, 87],[14, 88],[15, 89],[16, 90],[17, 139],[18, 140],[19, 141],[20, 142],[21, 20],[22, 126],[23, 80],[24, 80],[25, 89],[26, 90],[27, 90],[28, 90],[29, 90],[30, 89],[31, 90],[32, 89],[33, 140],[34, 89],[35, 141],[36, 89]])
const n8 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 91],[6, 92],[7, 93],[8, 94],[9, 95],[10, 96],[11, 97],[12, 98],[13, 99],[14, 100],[15, 101],[16, 102],[17, 143],[18, 144],[19, 145],[20, 146],[21, 20],[22, 126],[23, 91],[24, 91],[25, 101],[26, 102],[27, 102],[28, 102],[29, 102],[30, 101],[31, 102],[32, 101],[33, 144],[34, 101],[35, 145],[36, 101]])
const n9 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 103],[6, 104],[7, 105],[8, 106],[9, 107],[10, 108],[11, 109],[12, 110],[13, 111],[14, 112],[15, 113],[16, 114],[17, 147],[18, 148],[19, 149],[20, 150],[21, 20],[22, 126],[23, 103],[24, 103],[25, 113],[26, 114],[27, 114],[28, 114],[29, 114],[30, 113],[31, 114],[32, 113],[33, 148],[34, 113],[35, 149],[36, 113]])
const n10 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 68],[6, 69],[7, 70],[8, 71],[9, 72],[10, 73],[11, 74],[12, 75],[13, 76],[14, 77],[15, 78],[16, 79],[17, 151],[18, 152],[19, 153],[20, 154],[21, 20],[22, 126],[23, 68],[24, 68],[25, 78],[26, 79],[27, 79],[28, 79],[29, 79],[30, 78],[31, 79],[32, 78],[33, 152],[34, 78],[35, 153],[36, 78]])
const n11 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 56],[6, 57],[7, 58],[8, 59],[9, 60],[10, 61],[11, 62],[12, 63],[13, 64],[14, 65],[15, 66],[16, 67],[17, 155],[18, 156],[19, 157],[20, 158],[21, 20],[22, 126],[23, 56],[24, 56],[25, 66],[26, 67],[27, 67],[28, 67],[29, 67],[30, 66],[31, 67],[32, 66],[33, 156],[34, 66],[35, 157],[36, 66]])
const n12 = t([[29, 14],[30, 13],[31, 14],[32, 13]])
const n13 = t([[29, 13],[30, 13],[31, 13],[32, 13],[25, 13],[26, 13],[28, 13],[27, 13]])
const n14 = t([[29, 13],[30, 12],[31, 13],[32, 12]])
const n15 = t([[21, 9],[22, 9],[23, 10],[24, 10],[25, 9],[26, 9],[28, 10],[27, 10]])
const n16 = t([[29, 30],[30, 29],[31, 30],[32, 29]])
const n17 = t([[29, 29],[30, 28],[31, 29],[32, 28],[25, 28],[26, 28],[28, 28],[27, 28]])
const n18 = t([[29, 28],[30, 27],[31, 28],[32, 27]])
const n19 = t([[21, 6],[22, 6],[23, 25],[24, 25],[25, 6],[26, 6],[28, 25],[27, 25]])
const n20 = t([[29, 42],[30, 41],[31, 42],[32, 41]])
const n21 = t([[29, 41],[30, 40],[31, 41],[32, 40],[25, 40],[26, 40],[28, 40],[27, 40]])
const n22 = t([[29, 40],[30, 39],[31, 40],[32, 39]])
const n23 = t([[21, 36],[22, 36],[23, 37],[24, 37],[25, 36],[26, 36],[28, 37],[27, 37]])
const n24 = t([[29, 54],[30, 53],[31, 54],[32, 53]])
const n25 = t([[29, 53],[30, 52],[31, 53],[32, 52],[25, 52],[26, 52],[28, 52],[27, 52]])
const n26 = t([[29, 52],[30, 51],[31, 52],[32, 51]])
const n27 = t([[21, 48],[22, 48],[23, 49],[24, 49],[25, 48],[26, 48],[28, 49],[27, 49]])
const n28 = t([[29, 89],[30, 88],[31, 89],[32, 88]])
const n29 = t([[29, 88],[30, 87],[31, 88],[32, 87],[25, 87],[26, 87],[28, 87],[27, 87]])
const n30 = t([[29, 87],[30, 86],[31, 87],[32, 86]])
const n31 = t([[21, 13],[22, 13],[23, 84],[24, 84],[25, 13],[26, 13],[28, 84],[27, 84]])
const n32 = t([[29, 101],[30, 100],[31, 101],[32, 100]])
const n33 = t([[29, 100],[30, 99],[31, 100],[32, 99],[25, 99],[26, 99],[28, 99],[27, 99]])
const n34 = t([[29, 99],[30, 98],[31, 99],[32, 98]])
const n35 = t([[21, 95],[22, 95],[23, 96],[24, 96],[25, 95],[26, 95],[28, 96],[27, 96]])
const n36 = t([[29, 113],[30, 112],[31, 113],[32, 112]])
const n37 = t([[29, 112],[30, 111],[31, 112],[32, 111],[25, 111],[26, 111],[28, 111],[27, 111]])
const n38 = t([[29, 111],[30, 110],[31, 111],[32, 110]])
const n39 = t([[21, 107],[22, 107],[23, 108],[24, 108],[25, 107],[26, 107],[28, 108],[27, 108]])
const n40 = t([[29, 78],[30, 77],[31, 78],[32, 77]])
const n41 = t([[29, 77],[30, 76],[31, 77],[32, 76],[25, 76],[26, 76],[28, 76],[27, 76]])
const n42 = t([[29, 76],[30, 75],[31, 76],[32, 75]])
const n43 = t([[21, 72],[22, 72],[23, 73],[24, 73],[25, 72],[26, 72],[28, 73],[27, 73]])
const n44 = t([[29, 66],[30, 65],[31, 66],[32, 65]])
const n45 = t([[29, 65],[30, 64],[31, 65],[32, 64],[25, 64],[26, 64],[28, 64],[27, 64]])
const n46 = t([[29, 64],[30, 63],[31, 64],[32, 63]])
const n47 = t([[21, 60],[22, 60],[23, 61],[24, 61],[25, 60],[26, 60],[28, 61],[27, 61]])
const n48 = t([[0, 0],[1, 1],[2, 2],[3, 3],[4, 4],[5, 5],[6, 6],[7, 7],[8, 8],[9, 9],[10, 10],[11, 11],[12, 12],[13, 13],[14, 13],[15, 14],[16, 15],[17, 16],[18, 17],[19, 18],[20, 19],[21, 4],[22, 3],[23, 6],[24, 6],[25, 9],[26, 13],[27, 13],[28, 13],[29, 13],[30, 13],[31, 15],[32, 13],[33, 17],[34, 14],[35, 18],[36, 14],[37, 5],[38, 6],[39, 7],[40, 8],[41, 9]])
const n49 = t([[0, 0],[1, 1],[2, 2],[3, 3],[4, 4],[5, 5],[6, 6],[7, 7],[8, 8],[9, 9],[10, 10],[11, 11],[12, 12],[13, 13],[14, 13],[15, 14],[16, 15],[17, 16],[18, 17],[19, 18],[20, 19],[21, 13],[22, 11],[23, 13],[24, 11],[25, 13],[26, 13],[27, 11],[28, 12],[29, 4],[30, 3],[31, 6],[32, 6],[33, 17],[34, 14],[35, 18],[36, 14],[37, 5],[38, 6],[39, 7],[40, 8],[41, 9]])
const n50 = t([[21, 6],[22, 5],[23, 7],[24, 7],[25, 19],[26, 18],[28, 18],[27, 18]])
const n51 = t([[21, 7],[22, 6],[23, 8],[24, 8],[25, 18],[26, 17],[28, 17],[27, 17]])
const n52 = t([[21, 159]])
const n53 = t([[-1, 160]])
const n54 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 21],[6, 22],[7, 23],[8, 24],[9, 6],[10, 25],[11, 26],[12, 27],[13, 28],[14, 29],[15, 30],[16, 31],[17, 127],[18, 128],[19, 129],[20, 130],[21, 20],[22, 126],[23, 22],[24, 22],[25, 6],[26, 28],[27, 28],[28, 28],[29, 28],[30, 28],[31, 31],[32, 28],[33, 128],[34, 30],[35, 129],[36, 30],[37, 21],[38, 22],[39, 23],[40, 24],[41, 6]])
const n55 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 21],[6, 22],[7, 23],[8, 24],[9, 6],[10, 25],[11, 26],[12, 27],[13, 28],[14, 29],[15, 30],[16, 31],[17, 127],[18, 128],[19, 129],[20, 130],[21, 29],[22, 26],[23, 29],[24, 26],[25, 29],[26, 28],[27, 26],[28, 27],[29, 20],[30, 126],[31, 22],[32, 22],[33, 128],[34, 30],[35, 129],[36, 30],[37, 21],[38, 22],[39, 23],[40, 24],[41, 6]])
const n56 = t([[21, 22],[22, 21],[23, 23],[24, 23],[25, 130],[26, 129],[28, 129],[27, 129]])
const n57 = t([[21, 23],[22, 22],[23, 24],[24, 24],[25, 129],[26, 128],[28, 128],[27, 128]])
const n58 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 32],[6, 33],[7, 34],[8, 35],[9, 36],[10, 37],[11, 38],[12, 39],[13, 40],[14, 41],[15, 42],[16, 43],[17, 131],[18, 132],[19, 133],[20, 134],[21, 20],[22, 126],[23, 33],[24, 33],[25, 36],[26, 40],[27, 40],[28, 40],[29, 40],[30, 40],[31, 43],[32, 40],[33, 132],[34, 42],[35, 133],[36, 42],[37, 32],[38, 33],[39, 34],[40, 35],[41, 36]])
const n59 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 32],[6, 33],[7, 34],[8, 35],[9, 36],[10, 37],[11, 38],[12, 39],[13, 40],[14, 41],[15, 42],[16, 43],[17, 131],[18, 132],[19, 133],[20, 134],[21, 41],[22, 38],[23, 41],[24, 38],[25, 41],[26, 40],[27, 38],[28, 39],[29, 20],[30, 126],[31, 33],[32, 33],[33, 132],[34, 42],[35, 133],[36, 42],[37, 32],[38, 33],[39, 34],[40, 35],[41, 36]])
const n60 = t([[21, 33],[22, 32],[23, 34],[24, 34],[25, 134],[26, 133],[28, 133],[27, 133]])
const n61 = t([[21, 34],[22, 33],[23, 35],[24, 35],[25, 133],[26, 132],[28, 132],[27, 132]])
const n62 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 44],[6, 45],[7, 46],[8, 47],[9, 48],[10, 49],[11, 50],[12, 51],[13, 52],[14, 53],[15, 54],[16, 55],[17, 135],[18, 136],[19, 137],[20, 138],[21, 20],[22, 126],[23, 45],[24, 45],[25, 48],[26, 52],[27, 52],[28, 52],[29, 52],[30, 52],[31, 55],[32, 52],[33, 136],[34, 54],[35, 137],[36, 54],[37, 44],[38, 45],[39, 46],[40, 47],[41, 48]])
const n63 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 44],[6, 45],[7, 46],[8, 47],[9, 48],[10, 49],[11, 50],[12, 51],[13, 52],[14, 53],[15, 54],[16, 55],[17, 135],[18, 136],[19, 137],[20, 138],[21, 53],[22, 50],[23, 53],[24, 50],[25, 53],[26, 52],[27, 50],[28, 51],[29, 20],[30, 126],[31, 45],[32, 45],[33, 136],[34, 54],[35, 137],[36, 54],[37, 44],[38, 45],[39, 46],[40, 47],[41, 48]])
const n64 = t([[21, 45],[22, 44],[23, 46],[24, 46],[25, 138],[26, 137],[28, 137],[27, 137]])
const n65 = t([[21, 46],[22, 45],[23, 47],[24, 47],[25, 137],[26, 136],[28, 136],[27, 136]])
const n66 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 80],[6, 81],[7, 82],[8, 83],[9, 13],[10, 84],[11, 85],[12, 86],[13, 87],[14, 88],[15, 89],[16, 90],[17, 139],[18, 140],[19, 141],[20, 142],[21, 20],[22, 126],[23, 81],[24, 81],[25, 13],[26, 87],[27, 87],[28, 87],[29, 87],[30, 87],[31, 90],[32, 87],[33, 140],[34, 89],[35, 141],[36, 89],[37, 80],[38, 81],[39, 82],[40, 83],[41, 13]])
const n67 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 80],[6, 81],[7, 82],[8, 83],[9, 13],[10, 84],[11, 85],[12, 86],[13, 87],[14, 88],[15, 89],[16, 90],[17, 139],[18, 140],[19, 141],[20, 142],[21, 88],[22, 85],[23, 88],[24, 85],[25, 88],[26, 87],[27, 85],[28, 86],[29, 20],[30, 126],[31, 81],[32, 81],[33, 140],[34, 89],[35, 141],[36, 89],[37, 80],[38, 81],[39, 82],[40, 83],[41, 13]])
const n68 = t([[21, 81],[22, 80],[23, 82],[24, 82],[25, 142],[26, 141],[28, 141],[27, 141]])
const n69 = t([[21, 82],[22, 81],[23, 83],[24, 83],[25, 141],[26, 140],[28, 140],[27, 140]])
const n70 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 91],[6, 92],[7, 93],[8, 94],[9, 95],[10, 96],[11, 97],[12, 98],[13, 99],[14, 100],[15, 101],[16, 102],[17, 143],[18, 144],[19, 145],[20, 146],[21, 20],[22, 126],[23, 92],[24, 92],[25, 95],[26, 99],[27, 99],[28, 99],[29, 99],[30, 99],[31, 102],[32, 99],[33, 144],[34, 101],[35, 145],[36, 101],[37, 91],[38, 92],[39, 93],[40, 94],[41, 95]])
const n71 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 91],[6, 92],[7, 93],[8, 94],[9, 95],[10, 96],[11, 97],[12, 98],[13, 99],[14, 100],[15, 101],[16, 102],[17, 143],[18, 144],[19, 145],[20, 146],[21, 100],[22, 97],[23, 100],[24, 97],[25, 100],[26, 99],[27, 97],[28, 98],[29, 20],[30, 126],[31, 92],[32, 92],[33, 144],[34, 101],[35, 145],[36, 101],[37, 91],[38, 92],[39, 93],[40, 94],[41, 95]])
const n72 = t([[21, 92],[22, 91],[23, 93],[24, 93],[25, 146],[26, 145],[28, 145],[27, 145]])
const n73 = t([[21, 93],[22, 92],[23, 94],[24, 94],[25, 145],[26, 144],[28, 144],[27, 144]])
const n74 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 103],[6, 104],[7, 105],[8, 106],[9, 107],[10, 108],[11, 109],[12, 110],[13, 111],[14, 112],[15, 113],[16, 114],[17, 147],[18, 148],[19, 149],[20, 150],[21, 20],[22, 126],[23, 104],[24, 104],[25, 107],[26, 111],[27, 111],[28, 111],[29, 111],[30, 111],[31, 114],[32, 111],[33, 148],[34, 113],[35, 149],[36, 113],[37, 103],[38, 104],[39, 105],[40, 106],[41, 107]])
const n75 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 103],[6, 104],[7, 105],[8, 106],[9, 107],[10, 108],[11, 109],[12, 110],[13, 111],[14, 112],[15, 113],[16, 114],[17, 147],[18, 148],[19, 149],[20, 150],[21, 112],[22, 109],[23, 112],[24, 109],[25, 112],[26, 111],[27, 109],[28, 110],[29, 20],[30, 126],[31, 104],[32, 104],[33, 148],[34, 113],[35, 149],[36, 113],[37, 103],[38, 104],[39, 105],[40, 106],[41, 107]])
const n76 = t([[21, 104],[22, 103],[23, 105],[24, 105],[25, 150],[26, 149],[28, 149],[27, 149]])
const n77 = t([[21, 105],[22, 104],[23, 106],[24, 106],[25, 149],[26, 148],[28, 148],[27, 148]])
const n78 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 68],[6, 69],[7, 70],[8, 71],[9, 72],[10, 73],[11, 74],[12, 75],[13, 76],[14, 77],[15, 78],[16, 79],[17, 151],[18, 152],[19, 153],[20, 154],[21, 20],[22, 126],[23, 69],[24, 69],[25, 72],[26, 76],[27, 76],[28, 76],[29, 76],[30, 76],[31, 79],[32, 76],[33, 152],[34, 78],[35, 153],[36, 78],[37, 68],[38, 69],[39, 70],[40, 71],[41, 72]])
const n79 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 68],[6, 69],[7, 70],[8, 71],[9, 72],[10, 73],[11, 74],[12, 75],[13, 76],[14, 77],[15, 78],[16, 79],[17, 151],[18, 152],[19, 153],[20, 154],[21, 77],[22, 74],[23, 77],[24, 74],[25, 77],[26, 76],[27, 74],[28, 75],[29, 20],[30, 126],[31, 69],[32, 69],[33, 152],[34, 78],[35, 153],[36, 78],[37, 68],[38, 69],[39, 70],[40, 71],[41, 72]])
const n80 = t([[21, 69],[22, 68],[23, 70],[24, 70],[25, 154],[26, 153],[28, 153],[27, 153]])
const n81 = t([[21, 70],[22, 69],[23, 71],[24, 71],[25, 153],[26, 152],[28, 152],[27, 152]])
const n82 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 56],[6, 57],[7, 58],[8, 59],[9, 60],[10, 61],[11, 62],[12, 63],[13, 64],[14, 65],[15, 66],[16, 67],[17, 155],[18, 156],[19, 157],[20, 158],[21, 20],[22, 126],[23, 57],[24, 57],[25, 60],[26, 64],[27, 64],[28, 64],[29, 64],[30, 64],[31, 67],[32, 64],[33, 156],[34, 66],[35, 157],[36, 66],[37, 56],[38, 57],[39, 58],[40, 59],[41, 60]])
const n83 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 56],[6, 57],[7, 58],[8, 59],[9, 60],[10, 61],[11, 62],[12, 63],[13, 64],[14, 65],[15, 66],[16, 67],[17, 155],[18, 156],[19, 157],[20, 158],[21, 65],[22, 62],[23, 65],[24, 62],[25, 65],[26, 64],[27, 62],[28, 63],[29, 20],[30, 126],[31, 57],[32, 57],[33, 156],[34, 66],[35, 157],[36, 66],[37, 56],[38, 57],[39, 58],[40, 59],[41, 60]])
const n84 = t([[21, 57],[22, 56],[23, 58],[24, 58],[25, 158],[26, 157],[28, 157],[27, 157]])
const n85 = t([[21, 58],[22, 57],[23, 59],[24, 59],[25, 157],[26, 156],[28, 156],[27, 156]])
const n86 = t([[0, 0],[1, 1],[2, 2],[3, 3],[4, 4],[5, 5],[6, 6],[7, 7],[8, 8],[9, 9],[10, 10],[11, 11],[12, 12],[13, 13],[14, 13],[15, 14],[16, 15],[17, 16],[18, 17],[19, 18],[20, 19],[21, 13],[22, 13],[23, 13],[24, 13],[25, 12],[26, 11],[27, 9],[28, 10],[29, 4],[30, 3],[31, 6],[32, 6],[33, 17],[34, 14],[35, 18],[36, 14],[37, 5],[38, 6],[39, 7],[40, 8],[41, 9]])
const n87 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 21],[6, 22],[7, 23],[8, 24],[9, 6],[10, 25],[11, 26],[12, 27],[13, 28],[14, 29],[15, 30],[16, 31],[17, 127],[18, 128],[19, 129],[20, 130],[21, 29],[22, 28],[23, 29],[24, 28],[25, 27],[26, 26],[27, 6],[28, 25],[29, 20],[30, 126],[31, 22],[32, 22],[33, 128],[34, 30],[35, 129],[36, 30],[37, 21],[38, 22],[39, 23],[40, 24],[41, 6]])
const n88 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 32],[6, 33],[7, 34],[8, 35],[9, 36],[10, 37],[11, 38],[12, 39],[13, 40],[14, 41],[15, 42],[16, 43],[17, 131],[18, 132],[19, 133],[20, 134],[21, 41],[22, 40],[23, 41],[24, 40],[25, 39],[26, 38],[27, 36],[28, 37],[29, 20],[30, 126],[31, 33],[32, 33],[33, 132],[34, 42],[35, 133],[36, 42],[37, 32],[38, 33],[39, 34],[40, 35],[41, 36]])
const n89 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 44],[6, 45],[7, 46],[8, 47],[9, 48],[10, 49],[11, 50],[12, 51],[13, 52],[14, 53],[15, 54],[16, 55],[17, 135],[18, 136],[19, 137],[20, 138],[21, 53],[22, 52],[23, 53],[24, 52],[25, 51],[26, 50],[27, 48],[28, 49],[29, 20],[30, 126],[31, 45],[32, 45],[33, 136],[34, 54],[35, 137],[36, 54],[37, 44],[38, 45],[39, 46],[40, 47],[41, 48]])
const n90 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 80],[6, 81],[7, 82],[8, 83],[9, 13],[10, 84],[11, 85],[12, 86],[13, 87],[14, 88],[15, 89],[16, 90],[17, 139],[18, 140],[19, 141],[20, 142],[21, 88],[22, 87],[23, 88],[24, 87],[25, 86],[26, 85],[27, 13],[28, 84],[29, 20],[30, 126],[31, 81],[32, 81],[33, 140],[34, 89],[35, 141],[36, 89],[37, 80],[38, 81],[39, 82],[40, 83],[41, 13]])
const n91 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 91],[6, 92],[7, 93],[8, 94],[9, 95],[10, 96],[11, 97],[12, 98],[13, 99],[14, 100],[15, 101],[16, 102],[17, 143],[18, 144],[19, 145],[20, 146],[21, 100],[22, 99],[23, 100],[24, 99],[25, 98],[26, 97],[27, 95],[28, 96],[29, 20],[30, 126],[31, 92],[32, 92],[33, 144],[34, 101],[35, 145],[36, 101],[37, 91],[38, 92],[39, 93],[40, 94],[41, 95]])
const n92 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 103],[6, 104],[7, 105],[8, 106],[9, 107],[10, 108],[11, 109],[12, 110],[13, 111],[14, 112],[15, 113],[16, 114],[17, 147],[18, 148],[19, 149],[20, 150],[21, 112],[22, 111],[23, 112],[24, 111],[25, 110],[26, 109],[27, 107],[28, 108],[29, 20],[30, 126],[31, 104],[32, 104],[33, 148],[34, 113],[35, 149],[36, 113],[37, 103],[38, 104],[39, 105],[40, 106],[41, 107]])
const n93 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 68],[6, 69],[7, 70],[8, 71],[9, 72],[10, 73],[11, 74],[12, 75],[13, 76],[14, 77],[15, 78],[16, 79],[17, 151],[18, 152],[19, 153],[20, 154],[21, 77],[22, 76],[23, 77],[24, 76],[25, 75],[26, 74],[27, 72],[28, 73],[29, 20],[30, 126],[31, 69],[32, 69],[33, 152],[34, 78],[35, 153],[36, 78],[37, 68],[38, 69],[39, 70],[40, 71],[41, 72]])
const n94 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 56],[6, 57],[7, 58],[8, 59],[9, 60],[10, 61],[11, 62],[12, 63],[13, 64],[14, 65],[15, 66],[16, 67],[17, 155],[18, 156],[19, 157],[20, 158],[21, 65],[22, 64],[23, 65],[24, 64],[25, 63],[26, 62],[27, 60],[28, 61],[29, 20],[30, 126],[31, 57],[32, 57],[33, 156],[34, 66],[35, 157],[36, 66],[37, 56],[38, 57],[39, 58],[40, 59],[41, 60]])

type ThemeNames =
 | 'light'
 | 'light_granted'
 | 'light_black'
 | 'light_cream'
 | 'light_gray'
 | 'light_green'
 | 'light_navy'
 | 'light_orange'
 | 'light_red'
 | 'light_limegreen'
 | 'light_lightblue'
 | 'light_alt1'
 | 'light_granted_alt1'
 | 'light_black_alt1'
 | 'light_alt2'
 | 'light_granted_alt2'
 | 'light_black_alt2'
 | 'light_alt3'
 | 'light_granted_alt3'
 | 'light_black_alt3'
 | 'light_active'
 | 'light_granted_active'
 | 'light_black_active'
 | 'light_cream_alt1'
 | 'light_cream_alt2'
 | 'light_cream_alt3'
 | 'light_cream_active'
 | 'light_gray_alt1'
 | 'light_gray_alt2'
 | 'light_gray_alt3'
 | 'light_gray_active'
 | 'light_green_alt1'
 | 'light_green_alt2'
 | 'light_green_alt3'
 | 'light_green_active'
 | 'light_navy_alt1'
 | 'light_navy_alt2'
 | 'light_navy_alt3'
 | 'light_navy_active'
 | 'light_orange_alt1'
 | 'light_orange_alt2'
 | 'light_orange_alt3'
 | 'light_orange_active'
 | 'light_red_alt1'
 | 'light_red_alt2'
 | 'light_red_alt3'
 | 'light_red_active'
 | 'light_limegreen_alt1'
 | 'light_limegreen_alt2'
 | 'light_limegreen_alt3'
 | 'light_limegreen_active'
 | 'light_lightblue_alt1'
 | 'light_lightblue_alt2'
 | 'light_lightblue_alt3'
 | 'light_lightblue_active'

export const themes: Record<ThemeNames, Theme> = {
  light: n1,
  light_granted: n2,
  light_black: n3,
  light_cream: n4,
  light_gray: n5,
  light_green: n6,
  light_navy: n7,
  light_orange: n8,
  light_red: n9,
  light_limegreen: n10,
  light_lightblue: n11,
  light_alt1: n12,
  light_granted_alt1: n12,
  light_black_alt1: n12,
  light_alt2: n13,
  light_granted_alt2: n13,
  light_black_alt2: n13,
  light_alt3: n14,
  light_granted_alt3: n14,
  light_black_alt3: n14,
  light_active: n15,
  light_granted_active: n15,
  light_black_active: n15,
  light_active_SelectTrigger: n15,
  light_active_Card: n15,
  light_active_Checkbox: n15,
  light_active_Switch: n15,
  light_active_TooltipContent: n15,
  light_active_RadioGroupItem: n15,
  light_granted_active_SelectTrigger: n15,
  light_granted_active_Card: n15,
  light_granted_active_Checkbox: n15,
  light_granted_active_Switch: n15,
  light_granted_active_TooltipContent: n15,
  light_granted_active_RadioGroupItem: n15,
  light_black_active_SelectTrigger: n15,
  light_black_active_Card: n15,
  light_black_active_Checkbox: n15,
  light_black_active_Switch: n15,
  light_black_active_TooltipContent: n15,
  light_black_active_RadioGroupItem: n15,
  light_cream_alt1: n16,
  light_cream_alt2: n17,
  light_cream_alt3: n18,
  light_cream_active: n19,
  light_cream_active_SelectTrigger: n19,
  light_cream_active_Card: n19,
  light_cream_active_Checkbox: n19,
  light_cream_active_Switch: n19,
  light_cream_active_TooltipContent: n19,
  light_cream_active_RadioGroupItem: n19,
  light_gray_alt1: n20,
  light_gray_alt2: n21,
  light_gray_alt3: n22,
  light_gray_active: n23,
  light_gray_active_SelectTrigger: n23,
  light_gray_active_Card: n23,
  light_gray_active_Checkbox: n23,
  light_gray_active_Switch: n23,
  light_gray_active_TooltipContent: n23,
  light_gray_active_RadioGroupItem: n23,
  light_green_alt1: n24,
  light_green_alt2: n25,
  light_green_alt3: n26,
  light_green_active: n27,
  light_green_active_SelectTrigger: n27,
  light_green_active_Card: n27,
  light_green_active_Checkbox: n27,
  light_green_active_Switch: n27,
  light_green_active_TooltipContent: n27,
  light_green_active_RadioGroupItem: n27,
  light_navy_alt1: n28,
  light_navy_alt2: n29,
  light_navy_alt3: n30,
  light_navy_active: n31,
  light_navy_active_SelectTrigger: n31,
  light_navy_active_Card: n31,
  light_navy_active_Checkbox: n31,
  light_navy_active_Switch: n31,
  light_navy_active_TooltipContent: n31,
  light_navy_active_RadioGroupItem: n31,
  light_orange_alt1: n32,
  light_orange_alt2: n33,
  light_orange_alt3: n34,
  light_orange_active: n35,
  light_orange_active_SelectTrigger: n35,
  light_orange_active_Card: n35,
  light_orange_active_Checkbox: n35,
  light_orange_active_Switch: n35,
  light_orange_active_TooltipContent: n35,
  light_orange_active_RadioGroupItem: n35,
  light_red_alt1: n36,
  light_red_alt2: n37,
  light_red_alt3: n38,
  light_red_active: n39,
  light_red_active_SelectTrigger: n39,
  light_red_active_Card: n39,
  light_red_active_Checkbox: n39,
  light_red_active_Switch: n39,
  light_red_active_TooltipContent: n39,
  light_red_active_RadioGroupItem: n39,
  light_limegreen_alt1: n40,
  light_limegreen_alt2: n41,
  light_limegreen_alt3: n42,
  light_limegreen_active: n43,
  light_limegreen_active_SelectTrigger: n43,
  light_limegreen_active_Card: n43,
  light_limegreen_active_Checkbox: n43,
  light_limegreen_active_Switch: n43,
  light_limegreen_active_TooltipContent: n43,
  light_limegreen_active_RadioGroupItem: n43,
  light_lightblue_alt1: n44,
  light_lightblue_alt2: n45,
  light_lightblue_alt3: n46,
  light_lightblue_active: n47,
  light_lightblue_active_SelectTrigger: n47,
  light_lightblue_active_Card: n47,
  light_lightblue_active_Checkbox: n47,
  light_lightblue_active_Switch: n47,
  light_lightblue_active_TooltipContent: n47,
  light_lightblue_active_RadioGroupItem: n47,
  light_ListItem: n48,
  light_SelectTrigger: n48,
  light_Card: n48,
  light_Progress: n48,
  light_TooltipArrow: n48,
  light_SliderTrack: n48,
  light_granted_ListItem: n48,
  light_granted_SelectTrigger: n48,
  light_granted_Card: n48,
  light_granted_Progress: n48,
  light_granted_TooltipArrow: n48,
  light_granted_SliderTrack: n48,
  light_black_ListItem: n48,
  light_black_SelectTrigger: n48,
  light_black_Card: n48,
  light_black_Progress: n48,
  light_black_TooltipArrow: n48,
  light_black_SliderTrack: n48,
  light_active_ListItem: n48,
  light_active_Progress: n48,
  light_active_TooltipArrow: n48,
  light_active_SliderTrack: n48,
  light_granted_active_ListItem: n48,
  light_granted_active_Progress: n48,
  light_granted_active_TooltipArrow: n48,
  light_granted_active_SliderTrack: n48,
  light_black_active_ListItem: n48,
  light_black_active_Progress: n48,
  light_black_active_TooltipArrow: n48,
  light_black_active_SliderTrack: n48,
  light_Button: n49,
  light_SwitchThumb: n49,
  light_SliderThumb: n49,
  light_Tooltip: n49,
  light_ProgressIndicator: n49,
  light_granted_Button: n49,
  light_granted_SwitchThumb: n49,
  light_granted_SliderThumb: n49,
  light_granted_Tooltip: n49,
  light_granted_ProgressIndicator: n49,
  light_black_Button: n49,
  light_black_SwitchThumb: n49,
  light_black_SliderThumb: n49,
  light_black_Tooltip: n49,
  light_black_ProgressIndicator: n49,
  light_Checkbox: n50,
  light_Switch: n50,
  light_TooltipContent: n50,
  light_RadioGroupItem: n50,
  light_granted_Checkbox: n50,
  light_granted_Switch: n50,
  light_granted_TooltipContent: n50,
  light_granted_RadioGroupItem: n50,
  light_black_Checkbox: n50,
  light_black_Switch: n50,
  light_black_TooltipContent: n50,
  light_black_RadioGroupItem: n50,
  light_SliderTrackActive: n51,
  light_granted_SliderTrackActive: n51,
  light_black_SliderTrackActive: n51,
  light_active_SliderTrackActive: n51,
  light_granted_active_SliderTrackActive: n51,
  light_black_active_SliderTrackActive: n51,
  light_SheetOverlay: n52,
  light_DialogOverlay: n52,
  light_ModalOverlay: n52,
  light_granted_SheetOverlay: n52,
  light_granted_DialogOverlay: n52,
  light_granted_ModalOverlay: n52,
  light_black_SheetOverlay: n52,
  light_black_DialogOverlay: n52,
  light_black_ModalOverlay: n52,
  light_cream_SheetOverlay: n52,
  light_cream_DialogOverlay: n52,
  light_cream_ModalOverlay: n52,
  light_gray_SheetOverlay: n52,
  light_gray_DialogOverlay: n52,
  light_gray_ModalOverlay: n52,
  light_green_SheetOverlay: n52,
  light_green_DialogOverlay: n52,
  light_green_ModalOverlay: n52,
  light_navy_SheetOverlay: n52,
  light_navy_DialogOverlay: n52,
  light_navy_ModalOverlay: n52,
  light_orange_SheetOverlay: n52,
  light_orange_DialogOverlay: n52,
  light_orange_ModalOverlay: n52,
  light_red_SheetOverlay: n52,
  light_red_DialogOverlay: n52,
  light_red_ModalOverlay: n52,
  light_limegreen_SheetOverlay: n52,
  light_limegreen_DialogOverlay: n52,
  light_limegreen_ModalOverlay: n52,
  light_lightblue_SheetOverlay: n52,
  light_lightblue_DialogOverlay: n52,
  light_lightblue_ModalOverlay: n52,
  light_active_SheetOverlay: n52,
  light_active_DialogOverlay: n52,
  light_active_ModalOverlay: n52,
  light_granted_active_SheetOverlay: n52,
  light_granted_active_DialogOverlay: n52,
  light_granted_active_ModalOverlay: n52,
  light_black_active_SheetOverlay: n52,
  light_black_active_DialogOverlay: n52,
  light_black_active_ModalOverlay: n52,
  light_cream_active_SheetOverlay: n52,
  light_cream_active_DialogOverlay: n52,
  light_cream_active_ModalOverlay: n52,
  light_gray_active_SheetOverlay: n52,
  light_gray_active_DialogOverlay: n52,
  light_gray_active_ModalOverlay: n52,
  light_green_active_SheetOverlay: n52,
  light_green_active_DialogOverlay: n52,
  light_green_active_ModalOverlay: n52,
  light_navy_active_SheetOverlay: n52,
  light_navy_active_DialogOverlay: n52,
  light_navy_active_ModalOverlay: n52,
  light_orange_active_SheetOverlay: n52,
  light_orange_active_DialogOverlay: n52,
  light_orange_active_ModalOverlay: n52,
  light_red_active_SheetOverlay: n52,
  light_red_active_DialogOverlay: n52,
  light_red_active_ModalOverlay: n52,
  light_limegreen_active_SheetOverlay: n52,
  light_limegreen_active_DialogOverlay: n52,
  light_limegreen_active_ModalOverlay: n52,
  light_lightblue_active_SheetOverlay: n52,
  light_lightblue_active_DialogOverlay: n52,
  light_lightblue_active_ModalOverlay: n52,
  light_Label: n53,
  light_granted_Label: n53,
  light_black_Label: n53,
  light_cream_Label: n53,
  light_gray_Label: n53,
  light_green_Label: n53,
  light_navy_Label: n53,
  light_orange_Label: n53,
  light_red_Label: n53,
  light_limegreen_Label: n53,
  light_lightblue_Label: n53,
  light_active_Label: n53,
  light_granted_active_Label: n53,
  light_black_active_Label: n53,
  light_cream_active_Label: n53,
  light_gray_active_Label: n53,
  light_green_active_Label: n53,
  light_navy_active_Label: n53,
  light_orange_active_Label: n53,
  light_red_active_Label: n53,
  light_limegreen_active_Label: n53,
  light_lightblue_active_Label: n53,
  light_cream_ListItem: n54,
  light_cream_SelectTrigger: n54,
  light_cream_Card: n54,
  light_cream_Progress: n54,
  light_cream_TooltipArrow: n54,
  light_cream_SliderTrack: n54,
  light_cream_active_ListItem: n54,
  light_cream_active_Progress: n54,
  light_cream_active_TooltipArrow: n54,
  light_cream_active_SliderTrack: n54,
  light_cream_Button: n55,
  light_cream_SwitchThumb: n55,
  light_cream_SliderThumb: n55,
  light_cream_Tooltip: n55,
  light_cream_ProgressIndicator: n55,
  light_cream_Checkbox: n56,
  light_cream_Switch: n56,
  light_cream_TooltipContent: n56,
  light_cream_RadioGroupItem: n56,
  light_cream_SliderTrackActive: n57,
  light_cream_active_SliderTrackActive: n57,
  light_gray_ListItem: n58,
  light_gray_SelectTrigger: n58,
  light_gray_Card: n58,
  light_gray_Progress: n58,
  light_gray_TooltipArrow: n58,
  light_gray_SliderTrack: n58,
  light_gray_active_ListItem: n58,
  light_gray_active_Progress: n58,
  light_gray_active_TooltipArrow: n58,
  light_gray_active_SliderTrack: n58,
  light_gray_Button: n59,
  light_gray_SwitchThumb: n59,
  light_gray_SliderThumb: n59,
  light_gray_Tooltip: n59,
  light_gray_ProgressIndicator: n59,
  light_gray_Checkbox: n60,
  light_gray_Switch: n60,
  light_gray_TooltipContent: n60,
  light_gray_RadioGroupItem: n60,
  light_gray_SliderTrackActive: n61,
  light_gray_active_SliderTrackActive: n61,
  light_green_ListItem: n62,
  light_green_SelectTrigger: n62,
  light_green_Card: n62,
  light_green_Progress: n62,
  light_green_TooltipArrow: n62,
  light_green_SliderTrack: n62,
  light_green_active_ListItem: n62,
  light_green_active_Progress: n62,
  light_green_active_TooltipArrow: n62,
  light_green_active_SliderTrack: n62,
  light_green_Button: n63,
  light_green_SwitchThumb: n63,
  light_green_SliderThumb: n63,
  light_green_Tooltip: n63,
  light_green_ProgressIndicator: n63,
  light_green_Checkbox: n64,
  light_green_Switch: n64,
  light_green_TooltipContent: n64,
  light_green_RadioGroupItem: n64,
  light_green_SliderTrackActive: n65,
  light_green_active_SliderTrackActive: n65,
  light_navy_ListItem: n66,
  light_navy_SelectTrigger: n66,
  light_navy_Card: n66,
  light_navy_Progress: n66,
  light_navy_TooltipArrow: n66,
  light_navy_SliderTrack: n66,
  light_navy_active_ListItem: n66,
  light_navy_active_Progress: n66,
  light_navy_active_TooltipArrow: n66,
  light_navy_active_SliderTrack: n66,
  light_navy_Button: n67,
  light_navy_SwitchThumb: n67,
  light_navy_SliderThumb: n67,
  light_navy_Tooltip: n67,
  light_navy_ProgressIndicator: n67,
  light_navy_Checkbox: n68,
  light_navy_Switch: n68,
  light_navy_TooltipContent: n68,
  light_navy_RadioGroupItem: n68,
  light_navy_SliderTrackActive: n69,
  light_navy_active_SliderTrackActive: n69,
  light_orange_ListItem: n70,
  light_orange_SelectTrigger: n70,
  light_orange_Card: n70,
  light_orange_Progress: n70,
  light_orange_TooltipArrow: n70,
  light_orange_SliderTrack: n70,
  light_orange_active_ListItem: n70,
  light_orange_active_Progress: n70,
  light_orange_active_TooltipArrow: n70,
  light_orange_active_SliderTrack: n70,
  light_orange_Button: n71,
  light_orange_SwitchThumb: n71,
  light_orange_SliderThumb: n71,
  light_orange_Tooltip: n71,
  light_orange_ProgressIndicator: n71,
  light_orange_Checkbox: n72,
  light_orange_Switch: n72,
  light_orange_TooltipContent: n72,
  light_orange_RadioGroupItem: n72,
  light_orange_SliderTrackActive: n73,
  light_orange_active_SliderTrackActive: n73,
  light_red_ListItem: n74,
  light_red_SelectTrigger: n74,
  light_red_Card: n74,
  light_red_Progress: n74,
  light_red_TooltipArrow: n74,
  light_red_SliderTrack: n74,
  light_red_active_ListItem: n74,
  light_red_active_Progress: n74,
  light_red_active_TooltipArrow: n74,
  light_red_active_SliderTrack: n74,
  light_red_Button: n75,
  light_red_SwitchThumb: n75,
  light_red_SliderThumb: n75,
  light_red_Tooltip: n75,
  light_red_ProgressIndicator: n75,
  light_red_Checkbox: n76,
  light_red_Switch: n76,
  light_red_TooltipContent: n76,
  light_red_RadioGroupItem: n76,
  light_red_SliderTrackActive: n77,
  light_red_active_SliderTrackActive: n77,
  light_limegreen_ListItem: n78,
  light_limegreen_SelectTrigger: n78,
  light_limegreen_Card: n78,
  light_limegreen_Progress: n78,
  light_limegreen_TooltipArrow: n78,
  light_limegreen_SliderTrack: n78,
  light_limegreen_active_ListItem: n78,
  light_limegreen_active_Progress: n78,
  light_limegreen_active_TooltipArrow: n78,
  light_limegreen_active_SliderTrack: n78,
  light_limegreen_Button: n79,
  light_limegreen_SwitchThumb: n79,
  light_limegreen_SliderThumb: n79,
  light_limegreen_Tooltip: n79,
  light_limegreen_ProgressIndicator: n79,
  light_limegreen_Checkbox: n80,
  light_limegreen_Switch: n80,
  light_limegreen_TooltipContent: n80,
  light_limegreen_RadioGroupItem: n80,
  light_limegreen_SliderTrackActive: n81,
  light_limegreen_active_SliderTrackActive: n81,
  light_lightblue_ListItem: n82,
  light_lightblue_SelectTrigger: n82,
  light_lightblue_Card: n82,
  light_lightblue_Progress: n82,
  light_lightblue_TooltipArrow: n82,
  light_lightblue_SliderTrack: n82,
  light_lightblue_active_ListItem: n82,
  light_lightblue_active_Progress: n82,
  light_lightblue_active_TooltipArrow: n82,
  light_lightblue_active_SliderTrack: n82,
  light_lightblue_Button: n83,
  light_lightblue_SwitchThumb: n83,
  light_lightblue_SliderThumb: n83,
  light_lightblue_Tooltip: n83,
  light_lightblue_ProgressIndicator: n83,
  light_lightblue_Checkbox: n84,
  light_lightblue_Switch: n84,
  light_lightblue_TooltipContent: n84,
  light_lightblue_RadioGroupItem: n84,
  light_lightblue_SliderTrackActive: n85,
  light_lightblue_active_SliderTrackActive: n85,
  light_active_Button: n86,
  light_active_SwitchThumb: n86,
  light_active_SliderThumb: n86,
  light_active_Tooltip: n86,
  light_active_ProgressIndicator: n86,
  light_granted_active_Button: n86,
  light_granted_active_SwitchThumb: n86,
  light_granted_active_SliderThumb: n86,
  light_granted_active_Tooltip: n86,
  light_granted_active_ProgressIndicator: n86,
  light_black_active_Button: n86,
  light_black_active_SwitchThumb: n86,
  light_black_active_SliderThumb: n86,
  light_black_active_Tooltip: n86,
  light_black_active_ProgressIndicator: n86,
  light_cream_active_Button: n87,
  light_cream_active_SwitchThumb: n87,
  light_cream_active_SliderThumb: n87,
  light_cream_active_Tooltip: n87,
  light_cream_active_ProgressIndicator: n87,
  light_gray_active_Button: n88,
  light_gray_active_SwitchThumb: n88,
  light_gray_active_SliderThumb: n88,
  light_gray_active_Tooltip: n88,
  light_gray_active_ProgressIndicator: n88,
  light_green_active_Button: n89,
  light_green_active_SwitchThumb: n89,
  light_green_active_SliderThumb: n89,
  light_green_active_Tooltip: n89,
  light_green_active_ProgressIndicator: n89,
  light_navy_active_Button: n90,
  light_navy_active_SwitchThumb: n90,
  light_navy_active_SliderThumb: n90,
  light_navy_active_Tooltip: n90,
  light_navy_active_ProgressIndicator: n90,
  light_orange_active_Button: n91,
  light_orange_active_SwitchThumb: n91,
  light_orange_active_SliderThumb: n91,
  light_orange_active_Tooltip: n91,
  light_orange_active_ProgressIndicator: n91,
  light_red_active_Button: n92,
  light_red_active_SwitchThumb: n92,
  light_red_active_SliderThumb: n92,
  light_red_active_Tooltip: n92,
  light_red_active_ProgressIndicator: n92,
  light_limegreen_active_Button: n93,
  light_limegreen_active_SwitchThumb: n93,
  light_limegreen_active_SliderThumb: n93,
  light_limegreen_active_Tooltip: n93,
  light_limegreen_active_ProgressIndicator: n93,
  light_lightblue_active_Button: n94,
  light_lightblue_active_SwitchThumb: n94,
  light_lightblue_active_SliderThumb: n94,
  light_lightblue_active_Tooltip: n94,
  light_lightblue_active_ProgressIndicator: n94,
}
